module.exports =
  base: '/promoStandards'
  inventory:
    base: '/promoStandards/inventory'
    v_1_2_1: '/promoStandards/inventory/v_1_2_1'
    v_2_0_0: '/promoStandards/inventory/v_2_0_0'
  invoice:
    base: '/promoStandards/invoice'
    v_0_0_1: '/promoStandards/invoice/v_0_0_1'
  mediaContent:
    base: '/promoStandards/mediaContent'
    v_1_1_0: '/promoStandards/mediaContent/v_1_1_0'
  shipmentNotification:
    base: '/promoStandards/shipmentNotification'
    v_1_0_0: '/promoStandards/shipmentNotification/v_1_0_0'
  orderStatus:
    base: '/promoStandards/orderStatus'
    v_1_0_0: '/promoStandards/orderStatus/v_1_0_0'
  purchaseOrder:
    base: '/promoStandards/purchaseOrder'
    v_1_0_0: '/promoStandards/purchaseOrder/v_1_0_0'
  configuration:
    base: '/promoStandards/configuration'
    v_1_0_0: '/promoStandards/configuration/v_1_0_0'
  productData:
    base: '/promoStandards/productData'
    v_1_0_0: '/promoStandards/productData/v_1_0_0'



// WEBPACK FOOTER //
// ./~/oo-routes/routes/promoStandards.coffee